module.exports = __webpack_public_path__ + "static/p07_back-a7ebf0fe5de44bee2816b7a742e33eea.jpg";